import type {FC} from 'react';
import {useNavigate} from 'react-router-dom';
import {Button, Stack} from '@wellstone-solutions/web';

interface ActionButtonsProps {
  formId: string;
  form: {dirty: boolean; isValid: boolean; isSubmitting: boolean};
  onDelete?: () => void;
  isDeleting?: boolean;
}

export const ActionButtons: FC<ActionButtonsProps> = ({
  formId,
  form,
  onDelete,
  isDeleting = false,
}) => {
  const navigate = useNavigate();

  const saveDisabled = !form.isValid || !form.dirty || form.isSubmitting;

  return (
    <Stack direction="row" alignItems="center" sx={{mt: 5}}>
      <Button
        variant="outlined"
        onClick={() => navigate('/resources')}
        sx={styles.button}>
        Cancel
      </Button>
      <Button
        form={formId}
        type="submit"
        disabled={saveDisabled}
        variant="contained"
        data-testid="resource-save"
        sx={styles.saveButton}>
        Save
      </Button>
      {!!onDelete && (
        <Button
          variant="outlined"
          color="error"
          onClick={onDelete}
          disabled={isDeleting}
          data-testid="resource-delete"
          sx={styles.deleteButton}>
          Delete
        </Button>
      )}
    </Stack>
  );
};

const styles = {
  button: {
    width: 125,
  },
  saveButton: {
    width: 125,
    ml: 3,
  },
  deleteButton: {
    width: 125,
    ml: 'auto',
  },
};
